let acc = document.getElementsByClassName("accordion");
let accordion_index;

for (accordion_index = 0; accordion_index < acc.length; accordion_index++) {
  if (!acc[accordion_index].classList.contains('ignore-toggle')){
    acc[accordion_index].addEventListener("click", function ({currentTarget}) {
      let panel = this.nextElementSibling;
      let scrollTarget = currentTarget.closest('.scroll-target')
      if (this.classList.contains("active")) {
        panel.style.maxHeight = null;
        this.classList.remove("active");
        return;
      }
  
      for (i = 0; i < acc.length; i++) {
        if (!acc[i].classList.contains('ignore-toggle')){
          acc[i].nextElementSibling.style.maxHeight = null;
          acc[i].classList.remove("active");
    
        }
      }
      
      this.classList.toggle("active");
      
      if (this.classList.contains("active")) {
        panel.style.maxHeight = panel.scrollHeight + "px";
        if(window.innerWidth < 768){
           if(scrollTarget) {
            scrollTarget.scrollIntoView({ behavior: 'smooth' });
          }
        }
       
      } else if (!this.classList.contains("active")) {
        panel.style.maxHeight = null;
      }
    });
  }
}
